import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=04420ff6&scoped=true"
import script from "./EditDocument.vue?vue&type=script&lang=js"
export * from "./EditDocument.vue?vue&type=script&lang=js"
import style0 from "./EditDocument.vue?vue&type=style&index=0&id=04420ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04420ff6",
  null
  
)

export default component.exports